import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';
import { rememberLocation, restorablePath } from '../utils/lastLocation';

/**
 * Write down where the user is, on every navigation, so the app can come back
 * here after it was closed (see {@link useRestoreLocation}).
 *
 * Mounted ONCE, above the routes, rather than in the two layouts: a screen that
 * forgot to call it would be a hole in the memory. The layouts still mark which
 * APP was last used (see utils/lastApp) — a different question, answered even
 * for the landing pages this deliberately skips.
 *
 * Nothing is written while nobody is signed in: the login screen renders in
 * place of the routes, so this does not run at all then.
 */
export function useRememberLocation(): void {
    const { user } = useAuth();
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (!user) {
            return;
        }
        const path = restorablePath(pathname, search);
        if (path) {
            rememberLocation(user.id, path);
        }
    }, [user, pathname, search]);
}
